export default __webpack_public_path__ + "static/media/logo.d5349ac3.png";